module.exports = __webpack_public_path__ + "img/adaptable.a867cb71.png";